module.exports = __webpack_public_path__ + "6219bfe3150f2091d8a6428112d7c3dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_tina_mobile.jpg
// module id = 677
// module chunks = 0